module.exports = new __parcel__URL__("artaud.1a019dea.jpg").toString();